<template>
  <div style="position: relative">
    <pc v-if="IsPC"></pc>
    <phone v-else></phone>
  </div>
</template>

<script>
import pc from "./components/pc";
import phone from "./components/phone";
export default {
  name: "App",
  components: {
    pc,
    phone
  },
  beforeCreate() {},
  created() {},
  computed: {
    IsPC() {
      const userAgentInfo = navigator.userAgent;
      const Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      let flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      if (!flag) {
        document.querySelector("html").style.fontSize = "100vw";
      } else {
        document.querySelector("html").style.fontSize = "";
      }
      return flag;
    }
  }
};
</script>

<style lang="less">
html,
[lang^='zh'] body {
  font-family:"黑体","Microsoft YaHei","微软雅黑","MicrosoftJhengHei","华文细黑","STHeiti","MingLiu";
  padding: 0;
  margin: 0;
}
html,
[lang^='en'] body {
  font-family:"Microsoft YaHei","微软雅黑","MicrosoftJhengHei","华文细黑","STHeiti","MingLiu";
  padding: 0;
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
